/**
 * Welcome, welcome to the font awesome import script!
 * Register the name of the icon below prefixed with the import name tag.
 * If you need bell from Font Awesome Solid (FAS) it becomes fasBell,
 * chevron-up becomes fasChevronUp. Notice that styles need to be aliased
 * to avoid conflicts between imports.
 */
import { library } from '@fortawesome/fontawesome-svg-core'

// Font Awesome Solid (FAS)
import {
  faCheck as fasCheck,
  faExclamationTriangle as fasExclamationTriangle,
  faKey as fasKey,
  faUser as fasUser,
  faRedoAlt as fasRedoAlt,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  // Font Awesome Solid (FAS)
  fasCheck,
  fasExclamationTriangle,
  fasKey,
  fasUser,
  fasRedoAlt
)
